import Vue from 'vue'
import VueCookies from 'vue-cookies'
import API from '@szyx/axios'
Vue.use(VueCookies)
/** *************** 3代理商和4代理商销api (没有环境切换)************************************ */
const envApi = VueCookies.get('envApi')

export default {
  // 获取厂商
  // getAllFirm: () => API.GET(`/openapi/user/accountOverView`, { pageNum: 1, pageSize: 1000 }),
  // 批量添加厂商订阅服务包
  // packageAddBatch: (params) => API.POSTJSON('/tms-admin/api/package/addBatch', params),
}